import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import fineArtHeroImg from './images/fine-art-hero.png';

const useStyles = makeStyles((theme) => ({
  heroSection: {
    padding: '20px 60px 5% 60px',
    backgroundColor: '#0a0a0a',
    marginBottom: '60px',
    maxHeight: 450,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 20px 30px',
      maxHeight: 'none',
      marginBottom: '40px',
    }
  },
  heroInner: {
    maxWidth: 1314,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 0,
      alignItems: 'center',
    }
  },
  heroTextContainer: {
    flex: 1,
    maxWidth: '850px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 'auto',
    marginBottom: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      alignItems: 'center',
      textAlign: 'center',
      maxWidth: '100%',
    }
  },
  heroTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '64px',
    fontWeight: 400,
    lineHeight: '110%',
    marginBottom: '20px',
    color: '#ffffff',
    [theme.breakpoints.down('md')]: {
      fontSize: '52px',
    },
    [theme.breakpoints.down('sm')]: {
      fontFamily: '"Cormorant Garamond", serif',
      fontSize: '44px',
      fontWeight: 400,
      lineHeight: '100%',
      letterSpacing: '0%',
      maxWidth: '360px',
      margin: '0 auto 24px auto',
      textAlign: 'center',
    }
  },
  heroSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    color: 'rgba(255, 255, 255, 0.7)',
    lineHeight: '27px',
    marginBottom: '28px',
    fontWeight: 300,
    maxWidth: '560px',
    [theme.breakpoints.down('sm')]: {
      fontFamily: '"Roboto", sans-serif',
      fontSize: '16px',
      fontWeight: 200,
      lineHeight: '24px',
      letterSpacing: '0%',
      color: '#FFFFFF',
      maxWidth: '340px',
      margin: '0 auto 24px auto',
      textAlign: 'center',
    }
  },
  breadcrumbs: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '16px',
    gap: '12px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 400,
    color: '#ffffff',
    '& a': {
      color: '#ffffff',
      textDecoration: 'none',
      transition: 'color 0.2s ease',
      '&:hover': {
        color: '#FE5A97',
      }
    },
    '& span': {
      color: '#FE5A97',
      fontWeight: 500,
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      marginTop: '0px',
      fontFamily: '"Roboto", sans-serif',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0%',
      gap: '10px',
      margin: '0 auto',
      '& span': {
        fontFamily: '"Roboto", sans-serif',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '110%',
        letterSpacing: '0%',
        verticalAlign: 'middle',
      }
    }
  },
  heroImageContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  heroImage: {
    width: 'auto',
    maxHeight: '450px',
    objectFit: 'contain',
    display: 'block',
  },
}));

export const FineArtHeroSection = () => {
  const classes = useStyles();
  return (
    <Box className={classes.heroSection}>
      <Box className={classes.heroInner}>
        <Box className={classes.heroTextContainer}>
          <Typography className={classes.heroTitle}>
            Where Creativity Meets Elegance
          </Typography>
          <Typography className={classes.heroSubtitle}>
            Discover premium editorial photography, artistic storytelling, glamour, and exclusive visual experiences from verified creators.
          </Typography>
          <Typography className={classes.breadcrumbs}>
            <Link to="/">Home</Link>
            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.500001 10.5L5.5 5.5L0.5 0.500001" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Fine Art Glamour</span>
          </Typography>
        </Box>
        <Box className={classes.heroImageContainer}>
          <img
            src={fineArtHeroImg}
            alt="Where Creativity Meets Elegance"
            className={classes.heroImage}
          />
        </Box>
      </Box>
    </Box>
  );
};
